import { render } from "./ModernLayout.vue?vue&type=template&id=69f3bbbc&ts=true"
import script from "./ModernLayout.vue?vue&type=script&lang=ts"
export * from "./ModernLayout.vue?vue&type=script&lang=ts"

import "./ModernLayout.vue?vue&type=style&index=0&id=69f3bbbc&lang=scss"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__